<template>
  <v-dialog v-model="dialogScan" max-width="900">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="green" dark v-bind="attrs" v-on="on" class="mx-2">
        扫码搜索<v-icon right>mdi-crop-free</v-icon>
      </v-btn>
    </template>

    <v-container class="pa-6 my-container">
      <v-col>
        <h1>户主搜索</h1>
        <v-divider class="mx-4 my-1"></v-divider>
        <v-alert
          v-model="alert"
          border="left"
          close-text="Close Alert"
          color="#2A3B4D"
          dark
          dismissible
        >
          {{ alert_text }}
        </v-alert>
        <v-row>
          
          <v-col cols="8" sm="8" md="8">
            <!-- <v-select
            v-model="project_id"
            :items="projectsOptions"
            item-text="name"
            item-value="id"
            menu-props="auto"
            hide-details
            label="项目"
            single-line
            style="max-width: 300px;margin-left:auto !important;margin-right:0px !important;"
            class="mx-3 mb-3"
          ></v-select> -->
            <v-text-field
              autofocus
              v-model="scan.value"
              prepend-icon="mdi-barcode"
              class="ml-auto"
              label="扫码录入"
              hide-details
              single-line
              @input="handleScan"
              style="max-width: 300px;"
            />
          </v-col>
        </v-row>
        <div class="my-3" />
      </v-col>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="cancelDialog">取消</v-btn>
        <!-- <v-btn color="primary" @click="confirmDialog">确认</v-btn> -->
      </v-card-actions>
    </v-container>
  </v-dialog>
</template>

<script>
import { fetchProjectsList } from "@/api/projects";

export default {
  name: "SearchCustomerDialog",
  components: {},

  data: () => ({
    timeout: 3,
    snackbar: false,
    text: "",
    alert: false,
    alert_text: "",
    scan: {
      value: "",
      type: ""
    },
    objectItem: {},
    projectsOptions:[],
    project_id:"",
    stringItem: "",
    dialogScan: false,
  }),
  mounted() {
    this.getProjectsList()
  },
  methods: {
    handleScan() {
      console.log("handleScan");

      if (this.scan.value.length == 9) {
        this.scan.type = this.scan.value.substr(2, 1);

        if (this.scan.type == "8") {
          // const customer_code = Number(this.scan.value.substr(1, 6));
          // this.customer_code = 
          this.dialogScan = false;
          this.$parent.listQuery.project_id = Number(this.scan.value.substr(0, 2));
          this.$parent.listQuery.customer_code = Number(this.scan.value.substr(2, 7));
          console.log( Number(this.scan.value.substr(0, 2)))
          console.log( Number(this.scan.value.substr(2, 7)))
          this.$parent.getList();

          setTimeout(() => {
            this.scan.value = "";
            this.scan.type = "";
            this.project_id = "";
          }, 0.5 * 1000);
        }
      }
    },

    getProjectsList() {
      this.listLoading = true;
      console.log("getProjectsList");
      fetchProjectsList().then(response => {
        this.projectsOptions = response.data.items;
        setTimeout(() => {
          this.listLoading = false;
        }, 5 * 1000);
      });
    },

    confirmDialog() {
      this.dialogScan = false;
       this.$parent.listQuery.project_id = this.project_id
       this.$parent.listQuery.customer_code = this.customer_code
       this.$parent.getList();
       
    },

    cancelDialog() {
      this.dialogScan = false;
      this.scan = {
        type: "",
        value: ""
      };
      console.log("cancelDialog");
    },

    getNamefromOptions(options, key) {
      // return options[key]
      let showname = "";
      options.forEach(item => {
        if (item.key === key) {
          // console.log(key, item.key, item.display_name)
          showname = item.display_name;
        }
      });
      return showname;
    }
  }
};
</script>

<style lang="scss">

$colors: (0 #949696, 1 #4ba946);

$color: nth($colors, random(length($colors)));

@each $i in $colors {
  .customer-title-#{nth($i,1)} {
    color: nth($i, 2) !important;
    font-size: 42px;
    margin-left: 40px;
  }
}

.customer-detail {
  color: rgb(207, 131, 32);
  font-size: 18px;
  margin-left: 40px;
  font-weight: 500;
  // font-weight-light grey--text mx-10
}

.my-container {
  background-color: rgba(79, 79, 82, 0.9);
}


</style>
